import styled from "styled-components";
import { theme } from "../../utils/globalStyles/colors";
import Logo from "../../utils/globalStyles/logo/logo-02.png";

export const Container = styled.header`
  width: 100%;
  height: 80px;
  flex-shrink: 0; /* Impede que o header seja espremido quando houver muito conteúdo */
  background-color: ${theme.colors.base};
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* Dá uma leve sombra para separar do conteúdo rolável */
  z-index: 10;
`;

export const ImageContainer = styled.div`
  width: 100%;
  max-width: 800px; /* Limita a largura em monitores grandes */
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Image = styled.div`
  width: 100px; /* Tamanho ajustado e proporcional */
  height: 50px;
  border: none;
  background-image: url(${Logo});
  background-size: contain;
  background-position: left center;
  background-repeat: no-repeat;
`;

/* Botão do perfil: iniciais do usuário (círculo vazio enquanto carrega) */
export const ProfileButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 2px solid rgba(255, 255, 255, 0.85);
  border-radius: 50%;
  background: none;
  cursor: pointer;
  transition:
    opacity 0.2s ease,
    transform 0.15s ease;

  &:active {
    transform: scale(0.94);
  }

  @media (hover: hover) {
    &:hover {
      opacity: 0.85;
    }
  }
`;

export const AvatarPlaceholder = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.22);
`;
